export default "__VITE_ASSET__MMqnUZM71qxkFEbqGrVQcQ__"